import prepareComponent from "@bluframe/grapple/prepareComponent"
import { Image } from "@bluframe/mightychroma-mightytool-frontend-types"
import { useState } from "react"

import Item from "./Item"

export interface StatusPill {
  ariaLabel?: string
  id: string
  label: string
  onClick?: () => void
  tone?: "default" | "info" | "success" | "warning" | "error"
}

export interface Props {
  expandedItem?: React.ReactNode
  icon?: React.ReactNode
  id: string
  image?: Image
  isAdmin?: boolean
  isEditor?: boolean
  isExpanded?: boolean
  label: string
  statusPills?: StatusPill[]
  subtitlePrimary?: string
  subtitleSecondary?: string

  onDelete?: (id: string) => void

  onView?: (id: string) => void
}

export interface ComponentProps extends Omit<
  Props,
  "id" | "onDelete" | "onView"
> {
  isModalOpen: boolean
  isShowDelete: boolean
  isShowView: boolean
  statusPills?: StatusPill[]
  onModalClose: () => void
  onModalConfirm: () => void
  onModalOpen: () => void
  onView: () => void
}

const usePrepareComponent = ({ id, ...props }: Props): ComponentProps => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const onModalClose = () => {
    setIsModalOpen(false)
  }

  const onModalOpen = () => {
    setIsModalOpen(true)
  }

  const onModalConfirm = () => {
    props.onDelete?.(id)
    onModalClose()
  }

  const onView = () => {
    props.onView?.(id)
  }

  return {
    ...props,
    isModalOpen,
    isShowDelete: Boolean(props.onDelete),
    isShowView: Boolean(props.onView),
    statusPills: props.statusPills,
    onModalClose,
    onModalConfirm,
    onModalOpen,
    onView
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Item
)
